import {
	Component,
	OnInit,
	HostBinding,
	OnDestroy,
	ElementRef,
	AfterViewInit,
	ChangeDetectionStrategy
} from '@angular/core';
import { LayoutConfigService } from '../../../../../core/services/layout-config.service';
import * as objectPath from 'object-path';
import {interval, Subscription} from 'rxjs';
import { QuickSearchDirective } from '../../../../../core/directives/quick-search.directive';
import { QuickSearchService } from '../../../../../core/services/quick-search.service';
import { Router } from '@angular/router';
import { MensagensService, ConfirmDialogOptions } from 'max-ng-lib';
import { NotificacaoService } from '../../../../../services/notificacao.service';
import {enumTipoAlertaParametro} from '../../../../../core/enums/enums';
import {ParametroPortalService} from '../../../../../services';
import {AlertaSonoroService} from '../../../../../services/alerta-sonoro.service';

@Component({
	selector: 'm-notificacao-dropdown',
	templateUrl: './notificacao-dropdown.component.html',
	styleUrls: ['./notificacao-dropdown.component.scss'],
	changeDetection: ChangeDetectionStrategy.Default
})
export class NotificacaoDropdownComponent
	implements OnInit, OnDestroy, AfterViewInit {
	onSearch: Subscription;
	@HostBinding('class') classes = '';
	@HostBinding('id') id = 'm_quicksearch';
	@HostBinding('attr.m-dropdown-toggle') attrDropdownToggle = 'click';
	@HostBinding('attr.m-dropdown-persistent') attrDropdownPersistent = '1';
	@HostBinding('attr.m-quicksearch-mode') attrQuicksearchMode = 'dropdown';
	@HostBinding('attr.mQuickSearch')
	mQuickSearchDirective: QuickSearchDirective;

	notificacoes = [];
	naoLidas = 0;
	utilizaAlertaSonoro;
	tempoAlertaSonoro;
	intervaloAtualizacao: Subscription;
	tempoDecorrido: number = 0;
	private audio: HTMLAudioElement;
	private subscription: Subscription;
	notificacoesDataUTC = ['OCORRENCIA'];



	constructor(
		public mensagemService: MensagensService,
		private router: Router,
		private layoutConfigService: LayoutConfigService,
		private el: ElementRef,
		private quickSearchService: QuickSearchService,
		private notificacaoService: NotificacaoService,
		private parametroPortalService: ParametroPortalService,
		private alertaSonoroService: AlertaSonoroService
	) {
		this.layoutConfigService.onLayoutConfigUpdated$.subscribe(model => {
			const config = model.config;

			this.classes =
				'm-nav__item m-dropdown m-dropdown--large m-dropdown--arrow m-dropdown--align-center m-dropdown--mobile-full-width m-dropdown--skin-light m-list-search m-list-search--skin-light';

			this.classes +=
				' m-dropdown--skin-' +
				objectPath.get(config, 'header.search.dropdown.skin');
		});
		this.audio = new Audio();
		this.audio.src = './assets/app/media/sons/alerta-sonoro-notificacao.mp3';

	}

	ngOnInit(): void {
		this.subscription = this.alertaSonoroService.getAtivouAlertaSonoro().subscribe(ativouParametro => {
			if (!ativouParametro) {
				this.utilizaAlertaSonoro = false;
				this.encerrarSubscricao();
			} else if (!this.utilizaAlertaSonoro && ativouParametro){
				this.carregarDadosIniciais();
			}
		})
		this.carregarDadosIniciais();
	}

	carregarNotificacoes() {

		this.notificacaoService.listarNotificacoesPorResponsavel()
			.subscribe((itens: any) => {
				this.notificacoes = itens.map(item => {
					return{
						id: item.id,
						idRegistro: item.idRegistro,
						tipo: item.tipo,
						descricaoTipo: item.descricaoTipo,
						lida: item.lida,
						mensagem: item.mensagem,
						data: this.isPadraoDataUTC(item.tipo) ? item.dataUtc : item.data
					};
				});
				this.naoLidas = this.notificacoes.length;
				if (this.utilizaAlertaSonoro && this.naoLidas > 0) {
					this.tocarSomEspecifico(this.notificacoes[0].tipo);
				  }
				});
	}

	tocarSomEspecifico(tipo: string) {
		this.alertaSonoroService.getAtivouAlertaSonoro().subscribe(ativouSomGeral => {
		  if (ativouSomGeral) {
			const somEspecificoAtivado = this.alertaSonoroService.isSomEspecificoAtivado(tipo);
			if (somEspecificoAtivado) {
			  this.audio.play();
			}
		  }
		});
	  }



	ngOnDestroy() {
		this.onSearch.unsubscribe();
		this.encerrarSubscricao();
	}

	ngAfterViewInit(): void {
		Promise.resolve(null).then(() => {
			this.mQuickSearchDirective = new QuickSearchDirective(this.el);
			this.mQuickSearchDirective.ngAfterViewInit();

			// listen to search event
			this.onSearch = this.mQuickSearchDirective.onSearch$.subscribe(
				(mQuickSearch: any) => {
					mQuickSearch.showProgress();
					this.quickSearchService.search().subscribe(result => {
						// append search result
						mQuickSearch.showResult(result[0]);
						mQuickSearch.hideProgress();
					});
				}
			);
		});
	}

	verTodas() {

		this.router.navigateByUrl('/pages/notificacoes');
	}

	marcarComoLidas() {

		this.mensagemService
			.exibaConfirmDialog('Deseja dispensar todas as notificações? As mensagens não serão exibidas novamente!', '')
			.subscribe(result => {
				if (result.confirmDialogSelect === ConfirmDialogOptions.SIM) {
					this.notificacaoService.dispensarTodas().subscribe(() => {
						this.mensagemService.exibaToastSucesso('Notificações dispensadas!');
						this.carregarNotificacoes();
					});
				}
			});
	}

	tipoNotificacao = (value) => {
		let classeTipoNotificacao;
		switch (value.tipo) {
			case 'CHECKIN_FORA_LOCAL': classeTipoNotificacao = '../../../../../../assets/app/media/img/icons/icons-notificacoes/checkin.png';
				break;
			case 'CNH': classeTipoNotificacao = '../../../../../../assets/app/media/img/icons/icons-notificacoes/bateria.png';
				break;
			case 'EVENTO': classeTipoNotificacao = '../../../../../../assets/app/media/img/icons/icons-notificacoes/evento.png';
				break;
			case 'TEMPO_ESPERA': classeTipoNotificacao = '../../../../../../assets/app/media/img/icons/icons-notificacoes/em espera.png';
				break;
			case 'TEMPO_ENTREGA': classeTipoNotificacao = '../../../../../../assets/app/media/img/icons/icons-notificacoes/entrega inferior a 2 min.png';
				break;
			case 'BATERIA_FRACA': classeTipoNotificacao = '../../../../../../assets/app/media/img/icons/icons-notificacoes/bateria.png';
				break;
			case 'RETORNO_VIAGEM': classeTipoNotificacao = '../../../../../../assets/app/media/img/icons/icons-notificacoes/retorno_viagem.png';
				break;
			case 'TEMPO_ENTRE_CLIENTES': classeTipoNotificacao = '../../../../../../assets/app/media/img/icons/icons-notificacoes/bateria.png';
				break;
			case 'FILA_ESPERA': classeTipoNotificacao = '../../../../../../assets/app/media/img/icons/icons-notificacoes/em espera.png';
				break;
			case 'DEVOLUCAO': classeTipoNotificacao = '../../../../../../assets/app/media/img/icons/icons-notificacoes/devolução.png';
				break;
			case 'FURO_DE_SEQUENCIA_ENTREGA': classeTipoNotificacao = '../../../../../../assets/app/media/img/icons/icons-notificacoes/furo_sequencia_entrega.png';
				break;
			case 'ENTREGA_INFERIOR_2_MIN': classeTipoNotificacao = '../../../../../../assets/app/media/img/icons/icons-notificacoes/entrega inferior a 2 min.png';
				break;
			case 'ECONOMIA_BATERIA': classeTipoNotificacao = '../../../../../../assets/app/media/img/icons/icons-notificacoes/economia_bateria.png';
				break;
			case 'GPS_DESLIGADO': classeTipoNotificacao = '../../../../../../assets/app/media/img/icons/icons-notificacoes/gps_desligado.png';
				break;
			case 'REAGENDAMENTO': classeTipoNotificacao = '../../../../../../assets/app/media/img/icons/icons-notificacoes/reagendamento.png';
				break;
			case 'EXCESSO_DE_VELOCIDADE': classeTipoNotificacao = '../../../../../../assets/app/media/img/icons/icons-notificacoes/velocidade.png';
				break;
			case 'FURO_DE_CERCA': classeTipoNotificacao = '../../../../../../assets/app/media/img/icons/icons-notificacoes/furo-de-cerca.png';
				break;
			case 'OCORRENCIA': classeTipoNotificacao = '../../../../../../assets/app/media/img/icons/icons-notificacoes/ocorrencia.png';
				break;
			default: classeTipoNotificacao = '../../../../../../assets/app/media/img/icons/icons-notificacoes/bateria.png';
		}
		return classeTipoNotificacao;
	}

	detalhes(notificacao) {

		this.notificacaoService.dispensar(notificacao.id).subscribe(() => this.carregarNotificacoes());

		if (notificacao.tipo === 'EVENTO') {

			this.router.navigate(['/pages/consultas/eventos/edicao/', notificacao.idRegistro]);
		}

		if (notificacao.tipo === 'CHECKIN_FORA_LOCAL' || notificacao.tipo === 'TEMPO_ESPERA' || notificacao.tipo === 'TEMPO_ENTREGA'
			|| notificacao.tipo === 'TEMPO_ENTRE_CLIENTES' || notificacao.tipo === 'FILA_ESPERA' || notificacao.tipo === 'DEVOLUCAO'
			|| notificacao.tipo === 'FURO_DE_SEQUENCIA_ENTREGA' || notificacao.tipo === 'ENTREGA_INFERIOR_2_MIN' || notificacao.tipo === 'REAGENDAMENTO') {

			this.router.navigate(['/pages/consultas/entregas/edicao/', notificacao.idRegistro]);
		}
	}

	detalharNotificacao(notificacao) {
		return notificacao.tipo === 'CHECKIN_FORA_LOCAL' || notificacao.tipo === 'TEMPO_ESPERA' || notificacao.tipo === 'TEMPO_ENTREGA'
			|| notificacao.tipo === 'TEMPO_ENTRE_CLIENTES' || notificacao.tipo === 'FILA_ESPERA' || notificacao.tipo === 'DEVOLUCAO'
			|| notificacao.tipo === 'FURO_DE_SEQUENCIA_ENTREGA' || notificacao.tipo === 'ENTREGA_INFERIOR_2_MIN' || notificacao.tipo === 'EVENTO';
	}


	async carregarDadosIniciais() {
		const [[alertaSonoroParam], [tempoAlertaSonoroParam]] = await Promise.all([
			this.parametroPortalService.obterParametroPorTipos(enumTipoAlertaParametro.ALERTA_SONORO_NOTIFICACOES).toPromise(),
			this.parametroPortalService.obterParametroPorTipos(enumTipoAlertaParametro.ALERTA_SONORO_NOTIFICACOES_TEMPO).toPromise()
		]);

		this.utilizaAlertaSonoro = alertaSonoroParam && alertaSonoroParam.valor === 'S';
		this.tempoAlertaSonoro = tempoAlertaSonoroParam ? tempoAlertaSonoroParam.valor : 3;

		if (this.utilizaAlertaSonoro) {
			this.ativarPesquisaAutomaticaEfeitoSonoro();
			this.carregarNotificacoes();
		} else {
			this.carregarNotificacoes();
		}
	}


	ativarPesquisaAutomaticaEfeitoSonoro(){
		if (this.utilizaAlertaSonoro &&  this.tempoAlertaSonoro){
			this.intervaloAtualizacao = interval(60000).subscribe(() => {
				this.tempoDecorrido++;
				if (this.tempoDecorrido % this.tempoAlertaSonoro === 0) {
					this.carregarNotificacoes();
				}
			});
		}
	}

	encerrarSubscricao() {
		if (this.intervaloAtualizacao) {
			this.intervaloAtualizacao.unsubscribe();
		}
	}

	isPadraoDataUTC(tipoNotificacao: string): boolean {
		return  this.notificacoesDataUTC.some(tipo => tipo === tipoNotificacao );
	}
}
